import api from '../../api'
const state = {
    entities:[],
    agencies:[],
    guichet:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            event: "",
            ip_address: "",
            username: "",
            email: "",
            user_agent: "",        
            valeur: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        //console.log(state.entities.0)
        state.entities.forEach(element => {    
            
            let t=""
            if (element.new_values){
                for (var key in element.new_values) {
                    // check if the property/key is defined in the object itself, not in parent
                    if (element.new_values.hasOwnProperty(key)) {
                        t += key + ": <u style='color:red;'>" + element.old_values[key] + "</u> | <span style='color:green;font-weight:bold;'>" + element.new_values[key] +"</span><br/>"
                        row.valeur = t
                        //console.log(t);
                    }
                }
            }  
            row = {
                id: element.id,
                event: element.event.toUpperCase(),
                ip_address: element.ip_address === null ? null : element.ip_address.toUpperCase(),
                username: element.user === null ? null : element.user.name.toUpperCase(),
                email: element.user === null ? null : element.user.email,
                user_agent: element.user_agent,
                valeur: t,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: "<router-link to='/theme/agences/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    rowsAgency(state){
        let data = []
        let row = {
            id: "",
            event: "",
            ip_address: "",
            username: "",
            email: "",
            user_agent: "",        
            valeur: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.agencies.forEach(element => {    
            let t=""
            if (element.new_values){
                for (var key in element.new_values) {
                    // check if the property/key is defined in the object itself, not in parent
                    if (element.new_values.hasOwnProperty(key)) {
                        if (element.old_values.length==0){
                            t += key + ":" + element.new_values[key] + "<br/>"
                            //console.log(t)
                        }else{
                            t += key + ":<u>" + element.old_values[key]+ "</u>|" + element.new_values[key]+"<br/>"
                        }
                        row.valeur = t
                    }
                }
            }  
            row = {
                id: element.id,
                event: element.event.toUpperCase(),
                ip_address: element.ip_address === null ? null : element.ip_address.toUpperCase(),
                username: element.user === null ? null : element.user.name.toUpperCase(),
                email: element.user === null ? null : element.user.email,
                user_agent: element.user_agent,
                valeur: t,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: "<router-link to='/theme/agences/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    rowsGuichet(state){
        let data = []
        let row = {
            id: "",
            event: "",
            ip_address: "",
            username: "",
            email: "",
            user_agent: "",        
            valeur: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.guichet.forEach(element => {    
            let t=""
            if (element.new_values){
                for (var key in element.new_values) {
                    // check if the property/key is defined in the object itself, not in parent
                    if (element.new_values.hasOwnProperty(key)) {
                        if (element.old_values.length==0){
                            t += key + ":" + element.new_values[key] + "<br/>"
                            //console.log(t)
                        }else{
                            t += key + ":<u>" + element.old_values[key]+ "</u>|" + element.new_values[key]+"<br/>"
                        }
                        row.valeur = t
                    }
                }
            }  
            row = {
                id: element.id,
                event: element.event.toUpperCase(),
                ip_address: element.ip_address === null ? null : element.ip_address.toUpperCase(),
                username: element.user === null ? null : element.user.name.toUpperCase(),
                email: element.user === null ? null : element.user.email,
                user_agent: element.user_agent,
                valeur: t,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: "<router-link to='/theme/agences/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setHistoryEntity(state, historyEntity) {
        state.entities = historyEntity
    },
    setHistoryAgency(state, historyAgency) {
        state.agencies = historyAgency
    },
    setHistoryGuichet(state, historyGuichet) {
        state.guichet = historyGuichet
    },
    addAgency(state, agency){
        state.all.push(agency)
    }
}

const actions={
    get_histories_by_model({ commit },data){
        return api.histories.get_histories_by_model(data).then(response =>{  
            console.log("ma reponse : ",response.data.data)             
            commit('setHistoryEntity', response.data.data)

            return response.data.data
        })
    },
    get_histories_by_agency({ commit }, id){
        return api.histories.get_histories_by_agency(id).then(response =>{                  
            //console.log(response.data.data)  
            commit('setHistoryAgency', response.data.data)
            return response.data.data
        })
    },
    get_histories_by_atm({ commit }, id){
        return api.histories.get_histories_by_atm(id).then(response =>{       
            //console.log(response.data.data)
            commit('setHistoryGuichet', response.data.data)
            return response.data.data
        })
    },
    post_agency({commit},agence){
        return api.agency.post_agency(agence).then((response)=>{   
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    
    put_agency({commit},data){
        return api.agency.put_agency(data.id,data.agency).then((response)=>{
            console.log(response.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_agency({ commit }, id) {
        return api.agency.show_agency(id).then((response) => {
            return response.data.data;
        })
    },
    delete_agences({ commit }, id) {
        return api.agency.delete_agences(id).then((response) => {
            return response.data;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
